import React from "react"

/**
 * Indicates if current hot key zone is active (true) or inactive (false).
 */
export const HotKeyActivityContext = React.createContext<boolean>(true)

HotKeyActivityContext.displayName = "HotKeyActivityContext"
